import React, { useState, useEffect } from 'react';
import { getUserProvider} from '../../../actions/auth.js';
import MatchesRugbyCSV from './MatchesRugbyCSV.js';
import MatchesBasketCSV from './MatchesBasketCSV.js';
import SportEventsCSV from './SportEventsCSV.js';

const MultisportCalendarCSV = () => {
  const [template, setTemplate] = useState('');
  const [provider, setProvider] = useState('');
  const [isInputValid, setIsInputValid] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

   // Effet secondaire pour initialiser le provider après le rendu initial
   useEffect(() => {
    setProvider(getUserProvider());
  }, []); 

  // Fonction pour gérer le changement du template
  const handleTemplateChange = (selectedTemplate) => {
    setTemplate(selectedTemplate);
    setProvider('');
    if (template !== 'Données DSAS'){
      setIsInputValid(false);
    }else{
      setIsInputValid(true);
    }
  };

  // Fonction pour gérer le changement du provider
  const handleProviderChange = (e) => {
    setProvider(e.target.value);
  }; 

  // Fonction pour valider la saisie
  const handleValidation = () => {
    if ((template === 'Données DSAS' && provider.trim() !== '') || template !== 'Données DSAS') {
      setIsInputValid(true);
      setIsDisabled(true);
    }
  };

  // Fonction pour rendre le composant approprié en fonction des choix
  const renderMatchesComponent = () => {
    return <SportEventsCSV importOption='dropzone'/>;
  };

  return (
    <div style={{
      paddingTop: '15px',
      paddingBottom: '15px'
    }}>
      <div style={{
        display:'flex',
        paddingTop: '15px',
        paddingBottom: '15px'
      }}>
        {/* Sélection du template */}
          <>
             {/* Champ de saisie pour le provider */}
            {template === 'Données DSAS' && (
              <>
              <div style={{ width: '30%', display: 'flex'}}>
              <input
                  type="text"
                  style={{ padding: '11px', borderRadius: '5px', border: '1px solid #ccc', width: '100%'}}
                  placeholder="Entrez le provider"
                  value={provider}
                  onChange={handleProviderChange}
                  disabled={isDisabled} 
                />
               {
                  !isDisabled ? (
                    <button style={{ width: '70px' }} onClick={handleValidation}>
                      OK
                    </button>
                  ) : (
                    <button style={{ width: '70px' }} onClick={() => setIsDisabled(false)}>
                      Modifier
                    </button>
                  )
                }
              </div>
              </>
            )}
          </>
      </div>
      {/* Rendre le composant approprié */}
      {renderMatchesComponent()}
    </div>
  );
};

export default MultisportCalendarCSV;